import firebase from "./firebase.js";

const storageRef = firebase.storage().ref();

export default storageRef;
